import { useRef } from 'react';
import { Analytics } from '@vercel/analytics/react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import SuccessSection from './components/SuccessSection';
import Services from './components/Services';
import WhyChooseSection from './components/WhyChooseSection';
import Projects from './components/Projects';
import TestimonialsSection from './components/TestimonialsSection';
import Process from './components/Process';
import StrategyOfferSection from './components/StrategyOfferSection';
import ContactCard from './components/ContactCard';
import Footer from './components/Footer';

export default function App() {
  const contactRef = useRef(null);

  const scrollToContact = () => {
    contactRef.current?.focusForm?.();
  };

  return (
    <div className="font-sans">
      <Navbar onTalkClick={scrollToContact} />
      <Hero onTalkClick={scrollToContact} />
      <SuccessSection />
      <Services onTalkClick={scrollToContact} />
      <WhyChooseSection />
      <Projects onTalkClick={scrollToContact} />
      <TestimonialsSection />
      <Process onTalkClick={scrollToContact} />
      <StrategyOfferSection onTalkClick={scrollToContact} />
      <ContactCard ref={contactRef} className="mt-16" />
      <Footer />
      <Analytics />
    </div>
  );
}
